import React from "react";
import { Modal, Button, Input, List, Spin, message, notification, Divider, Icon } from "antd";
import firebase from "../../Firebase";

class DeletionSummaryModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      counts: {
        ops: 0,
        telas: 0,
        corte: 0,
        costura: 0,
        acabados: 0,
        almacen: 0,
        ing: 0,
        ddp: 0,
      },
      loadingCounts: false,
      isDeleting: false,
      confirmationText: "",
      password: "",
    };
  }

  componentDidUpdate(prevProps) {
    const { visible, prof } = this.props;
    if (visible && (visible !== prevProps.visible || prof !== prevProps.prof)) {
      if (prof) {
        this.fetchCounts();
      }
    } else if (!visible && prevProps.visible) {
      this.resetState();
    }
  }

  resetState = () => {
    this.setState({
      counts: {
        ops: 0,
        telas: 0,
        corte: 0,
        costura: 0,
        acabados: 0,
        almacen: 0,
        ing: 0,
        ddp: 0,
      },
      confirmationText: "",
      password: "",
      isDeleting: false,
    });
  };

  fetchCounts = async () => {
    const { prof } = this.props;
    this.setState({ loadingCounts: true });
    try {
      const commercialSnap = await firebase
        .firestore()
        .collection("comercial")
        .where("prof", "==", prof)
        .get();

      const ops = [];
      commercialSnap.forEach((doc) => {
        if (doc.data().op) ops.push(doc.data().op);
      });

      const uniqueOps = [...new Set(ops)];
      const newCounts = {
        ops: uniqueOps.length,
        telas: 0,
        corte: 0,
        costura: 0,
        acabados: 0,
        almacen: 0,
        ing: 0,
      };

      for (const op of uniqueOps) {
        const collections = ["ing", "ddp", "telas", "corte", "costura", "acabados", "almacen"];
        for (const coll of collections) {
          const snap = await firebase
            .firestore()
            .collection(coll)
            .where("op", "==", op)
            .get();
          newCounts[coll] += snap.size;
        }
      }
      this.setState({ counts: newCounts });
    } catch (error) {
      console.error("Error fetching counts:", error);
      message.error("Error al calcular registros relacionados");
    } finally {
      this.setState({ loadingCounts: false });
    }
  };

  handleConfirm = async () => {
    const { prof, onDeleteSuccess } = this.props;
    const { confirmationText, password } = this.state;

    if (confirmationText !== prof) {
      message.error("El número de proforma no coincide");
      return;
    }

    if (password !== "pcpedit246.") {
      message.error("Contraseña administrativa incorrecta");
      return;
    }

    this.setState({ isDeleting: true });

    try {
      const commercialSnap = await firebase
        .firestore()
        .collection("comercial")
        .where("prof", "==", prof)
        .get();

      // Se recolectan funciones, no promesas: `.delete()` se ejecuta en el
      // momento de llamarlo, asi que empujar `...delete()` borraria la
      // proforma antes de saber si el barrido de las demas colecciones va a
      // funcionar, dejando huerfanos y nada desde donde reintentar.
      const pasos = [];
      const ops = [];

      commercialSnap.forEach((doc) => {
        if (doc.data().op) ops.push(doc.data().op);
        pasos.push(() =>
          firebase.firestore().collection("comercial").doc(doc.id).delete()
        );
      });

      const uniqueOps = [...new Set(ops)];
      const collections = ["ing", "ddp", "telas", "corte", "costura", "acabados", "almacen"];

      for (const op of uniqueOps) {
        for (const coll of collections) {
          const snap = await firebase.firestore().collection(coll).where("op", "==", op).get();
          snap.forEach((doc) => {
            pasos.push(() =>
              firebase.firestore().collection(coll).doc(doc.id).delete()
            );
          });
        }
      }

      // El barrido termino sin errores: recien aqui se borra algo.
      await Promise.all(pasos.map((paso) => paso()));
    } catch (error) {
      console.error("Error during deletion:", error);
      notification.error({
        message: "Error de Eliminación",
        description: "Hubo un problema al intentar eliminar los registros.",
      });
      this.setState({ isDeleting: false });
      return;
    }

    // Fuera del try: si el callback del padre falla, no debe disfrazarse de
    // fallo de borrado. Los documentos ya se eliminaron llegados a este punto.
    this.setState({ isDeleting: false });

    notification.success({
      message: "Eliminación Completada",
      description: `La Proforma ${prof} y todos sus registros asociados han sido eliminados.`,
    });

    onDeleteSuccess();
  };

  render() {
    const { visible, onCancel, prof } = this.props;
    const { counts, loadingCounts, isDeleting, confirmationText, password } = this.state;

    const isNameCorrect = confirmationText === prof;
    const isPasswordCorrect = password === "pcpedit246.";

    const summaryData = [
      { label: "Ordenes de producción", value: counts.ops, icon: "📦" },
      { label: "Registros de DDP", value: counts.ddp, icon: "📋" },
      { label: "Registros de Telas", value: counts.telas, icon: "🧵" },
      { label: "Registros de Corte", value: counts.corte, icon: "✂️" },
      { label: "Registros de Costura", value: counts.costura, icon: "🧥" },
      { label: "Registros de Acabados", value: counts.acabados, icon: "✨" },
      { label: "Registros de Almacén", value: counts.almacen, icon: "🏭" },
    ];

    return (
      <Modal
        title={
          <div style={{ 
            display: "flex", 
            alignItems: "center", 
            gap: "8px", 
            backgroundColor: "#ff4d4f", 
            color: "white", 
            margin: "-16px -24px", 
            padding: "16px 24px",
            borderRadius: "4px 4px 0 0" 
          }}>
            <Icon type="exclamation-circle" style={{ color: "white", fontSize: "20px" }} />
            <span style={{ fontSize: "18px", fontWeight: "bold", lineHeight: "20px" }}>Confirmar Eliminación</span>
          </div>
        }
        visible={visible}
        onCancel={onCancel}
        footer={[
          <Button key="cancel" onClick={onCancel} disabled={isDeleting}>
            Cancelar
          </Button>,
          <Button
            key="delete"
            type="danger"
            loading={isDeleting}
            onClick={this.handleConfirm}
            disabled={loadingCounts || !isNameCorrect || !isPasswordCorrect}
            style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
          >
            {!isDeleting && <Icon type="delete" style={{ marginRight: 8 }} />}
            <span>Eliminar Todo</span>
          </Button>,
        ]}
        width={480}
        centered
      >
        <div style={{ padding: "10px 0" }}>
          <p>
            Estás a punto de eliminar la Proforma: <strong style={{ fontWeight: "bold" }}>{prof}</strong>
          </p>
          <div style={{ marginTop: 15 }}>
            <p style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: "14px" }}>Resumen de registros que se eliminarán permanentemente:</p>
            <Spin spinning={loadingCounts}>
              <List
                size="small"
                dataSource={summaryData}
                renderItem={(item) => (
                  <List.Item style={{ padding: "4px 0", display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ marginRight: 8, fontSize: "16px" }}>{item.icon}</span>
                      <span>{item.label}</span>
                    </div>
                    <span style={{ fontWeight: "bold" }}>{item.value}</span>
                  </List.Item>
                )}
              />
            </Spin>
          </div>

          <Divider style={{ margin: "20px 0" }} />

          <div style={{ background: "#fff2f0", padding: "12px", borderRadius: "8px", border: "1px solid #ffccc7", marginBottom: 20, display: "flex", alignItems: "center" }}>
            <Icon type="warning" style={{ color: "#ff4d4f", marginRight: 8, fontSize: "16px" }} />
            <span style={{ color: "#ff4d4f", fontWeight: "bold" }}>
              Atención: Esta acción no se puede deshacer.
            </span>
          </div>

          <div style={{ marginBottom: 15 }}>
            <span style={{ fontWeight: "bold", display: "block", marginBottom: 8 }}>
              1. Escriba el número de la Proforma <code style={{ backgroundColor: "#f5f5f5", padding: "2px 4px", borderRadius: "4px" }}>{prof}</code>:
            </span>
            <Input
              placeholder={`Escriba "${prof}"`}
              value={confirmationText}
              onChange={(e) => this.setState({ confirmationText: e.target.value })}
              disabled={isDeleting || loadingCounts}
            />
          </div>

          <div style={{ marginBottom: 10, opacity: isNameCorrect ? 1 : 0.5, transition: "opacity 0.3s" }}>
            <span style={{ fontWeight: "bold", display: "block", marginBottom: 8 }}>
              2. Ingrese la contraseña administrativa:
            </span>
            <Input.Password
              placeholder="Contraseña"
              value={password}
              onChange={(e) => this.setState({ password: e.target.value })}
              disabled={isDeleting || loadingCounts || !isNameCorrect}
              prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default DeletionSummaryModal;
